import { del, get, post, put } from "../api_helper"
import * as url from "./url"

const getUsers = () => get(url.GET_USERS)
const getUserByEmail = email => get(url.GET_USER_BY_EMAIL + "/" + email)
const postAddUser = data => post(url.POST_USER, data)
const putEditUser = data => put(url.PUT_USER, data)
const putEditPasswordUser = data => put(url.PUT_USER_EDIT_PASSWORD, data)
const putResetPasswordUser = data => put(url.PUT_USER_RESET_PASSWORD, data)
const deleteUser = data => del(url.DELETE_USER, data)

export {
  putEditUser,
  getUsers,
  postAddUser,
  deleteUser,
  getUserByEmail,
  putResetPasswordUser,
  putEditPasswordUser
}
